import './../../Player.css';

import React, {useState, useRef, useContext, CSSProperties, useEffect} from 'react';
import ReactPlayer from 'react-player';
import { PlayerContext } from '../../PlayerContext';
import { openFullscreen, checkMobile, isTikTokInAppBrowser, getFileFormat, getFileNameFromUrl, isImg, isVideo, getTextWidth, lighterColor, printObj, isIOS, isAndroid, isFirefox, rgbaHexToRgbHexBlended, isSafari, isInstagramInAppBrowser, isEdge, browserLocales, isIpad, isCafeUprealityDemoStoryId } from '../../Utils';
import { analyticsManager } from '../../../index';
import { useTranslation } from 'react-i18next';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.css';
import { getStoredPixelConsent } from '../../PixelConsentOverlay';
import Sticker from './Sticker';
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';
import VolumeOffIcon from '@mui/icons-material/VolumeOff';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import {Image} from 'react-native';
import Menu from './Menu';
import { useMediaQuery } from 'react-responsive';
import * as Sentry from "@sentry/react";
import { StickerContext } from '../../StickerContext';
import CloseButton from '../../side_menu/components/CloseButton';
import FadeInPanel from '../../side_menu/components/FadeInPanel';
import Infos from './Infos';
import { set } from 'firebase/database';
import Promotion from './Promotion';
import CancelIcon from '@mui/icons-material/Cancel';

export const menuType = "menu";
export const insideType = "inside";

var interactedWithGallery = false;
var menuGalleryOpened = false;

function StickerGallery(props){
    const [isMediasGalleryOpened, setIsMediasGalleryOpened] = useState(false);
    const [isVirtualTourOpened, setIsVirtualTourOpened] = useState(false);
    const [retries, setRetries] = useState(0);
    const [isMenuOpened, setIsMenuOpened] = useState(false);
    const [closeGalleryWithMenu, setCloseGalleryWithMenu] = useState(false);

    const retriesNb = 1;
    const pauseVideo = useContext(PlayerContext).get("pauseVideo");

    const setActiveFeature = useContext(PlayerContext).get("setActiveFeature");
    const activeFeature = useContext(PlayerContext).get("activeFeature");
    menuGalleryOpened = activeFeature === "menu";

    const propagateFocusChange = useContext(PlayerContext).get("propagateFocusChange");
    const setInsideStickerClicked = useContext(PlayerContext).get("setInsideStickerClicked");
    const setMenuStickerClicked = useContext(PlayerContext).get("setMenuStickerClicked");
    const windowDimensions = useContext(PlayerContext).get("windowDimensions");
    const storyDimensions = useContext(PlayerContext).get("storyDimensions");
    const sizeMultiplier = useContext(PlayerContext).get("sizeMultiplier"); 
    const [menuHeight, setMenuHeight] = useState(storyDimensions.containerHeight * 9 / 16);
    const primaryColor = useContext(PlayerContext).get("primaryColor");
    const secondaryColor = useContext(PlayerContext).get("secondaryColor");
    const menuColor = useContext(PlayerContext).get("menuColor");
    const titleFont = useContext(StickerContext).get("menuTitleFont");
    const textFont = useContext(StickerContext).get("menuTextFont"); 
    const titleFontSizeMult = titleFont === "Bestro" ? 2 : 1;
    const appAnalyticsManager = useContext(PlayerContext).get("appAnalyticsManager");   
    const fromMaker = useContext(PlayerContext).get("fromMaker");
    const playMode = useContext(PlayerContext).get("playMode");
    const fromDemo = useContext(PlayerContext).get("fromDemo");
    const playerOnDesktop = useContext(PlayerContext).get("playerOnDesktop");
    const idPrefix = fromDemo ? (fromDemo +"-") : "";
    const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' });     
    const snackSwipeAlreadyDisplayed = useContext(StickerContext).get("snackSwipeAlreadyDisplayed");
    const setSnackSwipeAlreadyDisplayed = useContext(StickerContext).get("setSnackSwipeAlreadyDisplayed");
    const playAudio = useContext(PlayerContext).get("playAudio");    
    const setPlayAudio = useContext(PlayerContext).get("setPlayAudio");  
    const [musicPlayingAtOpening, setMusicPlayingAtOpening] = useState(false); 
    const audioAlreadyDisabled = useContext(PlayerContext).get("audioAlreadyDisabled");
    const [neverSwiped, setNeverSwiped] = useState(true);

    const { t } = useTranslation();

    const galleryPanelRootStyle = {
        position: 'absolute',
        top: 0,
        left: 0,
        width: storyDimensions.containerWidth,
        height: storyDimensions.containerHeight,
        zIndex: 20,
    };

    let title = t('MediasGalleryTitle');
    if (props.mediasType === insideType){
        if (props.story && props.story.posId === "ChIJC4g4KBNx5kcRH_z3vKUpnZw" ){
            title = "Galerie";
        }
        else if (props.story && (props.storyId === "32etJrIVkk0BjlVtPLG1" || props.story.baseStoryId === "32etJrIVkk0BjlVtPLG1") ){
            title = t("DishesGalleryTitle");
        }
        else {
            title = t('VirtualTourTitle');
        }
    }

    const showMenu = activeFeature == null || activeFeature === "menu";
    const showInside = activeFeature == null || activeFeature === "inside";

    useEffect(()=>{
        // NOT gallery appearance condition
        if (!(((isMediasGalleryOpened && props.mediasType === menuType) || (isVirtualTourOpened && props.mediasType === insideType)) && ((props.mediasType === menuType && activeFeature === "menu") || (props.mediasType === insideType && activeFeature === "inside")))){
            if (musicPlayingAtOpening){
                const ambiantPlayer = document.getElementById(idPrefix + "audio-player");                
                if (musicPlayingAtOpening && ambiantPlayer){
                    ambiantPlayer.play();   
                    setMusicPlayingAtOpening(false);
                }   
            }                  
            muteGalleryVideos();           
        }
    }, [isMediasGalleryOpened, isVirtualTourOpened, activeFeature, props.mediasType]);

    function muteGalleryVideos(){        
        const galleryContainer = document.getElementById("gallery-container");
        const videoElmts = galleryContainer != null ? galleryContainer.getElementsByTagName("video") : null;
        // reset volume btns
        if (props.medias && galleryContainer && videoElmts){
            for (let i = 0; i< props.medias.length; i++){                
                const volumeOn = document.getElementById(idPrefix + "volume-btn" + i + "-on");
                const volumeOff = document.getElementById(idPrefix + "volume-btn" + i + "-off");
                if (volumeOn && volumeOff){
                    if (volumeOn.style.visibility === "visible" || volumeOff.style.visibility === "visible"){                        
                        volumeOn.style.visibility = "visible"
                        volumeOff.style.visibility = "hidden";
                    }
                    else {
                        // case where the video has no sound                        
                    }
                }                
            }
        }

        if (videoElmts != null && videoElmts.length > 0){
            for (let i = 0; i < videoElmts.length; i++){
                videoElmts[i].muted = true;
            }
        }
    }    
     
    useEffect(() => {           
          
        if (activeFeature === "menu" && !interactedWithGallery && !(! checkMobile() || isTikTokInAppBrowser() && isIOS() && !isAndroid())){   
            const contentNb = (props.medias != null ? props.medias.length : 0); 
            if (contentNb === 1) return;                    
            setTimeout(()=>{
                if (interactedWithGallery) return;
                sleep(0)
                    .then(() => { 
                        const element = document.getElementsByClassName("axis-horizontal")[0];                        
                        if (interactedWithGallery || !menuGalleryOpened) throw Error();
                        if (element != null){
                            const scrollWidth = storyDimensions.containerWidth <= 400 ? 40 : (storyDimensions.containerWidth - 400)/2 + 24;
                            element.scroll({
                                top: 0,
                                left: scrollWidth,
                                behavior: "smooth",
                            });
                        }                
                    })
                    .then(()=>sleep(1000))
                    .then(()=>{                        
                        const element = document.getElementsByClassName("axis-horizontal")[0];
                        if (!menuGalleryOpened) throw Error();                        
                        if (element != null){
                            element.scroll({
                                top: 0,
                                left: 0,
                                behavior: "smooth",
                            });  
                            interactedWithGallery = true;                                                      
                        } 
                    })
                    .catch((error)=>{});
            }, 1500);                        
        }

        if (! activeFeature){
            setIsMenuOpened(false);
        }

        function sleep(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
          }
      }, [activeFeature]);

    const openMediasGallery = () => {                     
        if (!fromMaker /*&& !fromDemo*/ && !playerOnDesktop && !audioAlreadyDisabled && !playAudio){            
            const ambiantPlayer = document.getElementById(idPrefix + "audio-player");
            if (ambiantPlayer && ambiantPlayer.paused){
                try {
                    ambiantPlayer.play();                
                } catch(error){}
            }
            setPlayAudio(true);
        }
        pauseVideo(); 
        //checkBgVideoPlaying();
        openFullscreen();
        setMusicPlayingAtOpening(true && playAudio);
        if (setActiveFeature("menu") === false) {
            return;
        }
        setIsMediasGalleryOpened(true);
        setMenuStickerClicked(true);
            
        analyticsManager.logOpenMenuTag(props.storyId, playMode, true);

        if (appAnalyticsManager)
            appAnalyticsManager.clickedMenu();  

        if (getStoredPixelConsent() === 'accepted') {
            if (window.ttq){
                window.ttq.track('ViewContent', {                
                    "contents": [
                        {              
                            "content_id": "0",           
                            "content_name": "menu",
                        }
                    ],
                });
            }
            if (window.fbq){                    
                window.fbq('track', 'ViewContent', {"content_name": "menu"});
            }
        }
        
        // Display directly the menu        
        if (props.mediasType === menuType && (props.story.menuTypeShown === "external" || props.story.menuTypeShown === "optimized")){             
            setCloseGalleryWithMenu(true);            
            selectForFullScreen(0, null);
            // when displaying an integrated menu, we have to close the gallery frame            
            if (props.story.menuTypeShown === "external" || props.story.menuTypeShown === "optimized" && !props.story.menuId && (!props.story.menuReformatDate  || props.story.menuReformatDate && (playMode === "play" || playMode === "review")) && !props.story.menuId && playMode !== "demo" && !isCafeUprealityDemoStoryId(props.storyId)){                
                propagateFocusChange(true);       
            }     
        }

      }; 

    const openVirtualTour = () => {       
        if (!fromMaker /*&& !fromDemo*/ && !playerOnDesktop && !audioAlreadyDisabled && !playAudio){            
            const ambiantPlayer = document.getElementById(idPrefix + "audio-player");
            if (ambiantPlayer && ambiantPlayer.paused){
                try {
                    ambiantPlayer.play();                
                } catch(error){}
            }
            setPlayAudio(true);
        }
        pauseVideo(); 
        //checkBgVideoPlaying();        
        openFullscreen();
        setMusicPlayingAtOpening(true && playAudio);
        setActiveFeature("inside");
        setIsVirtualTourOpened(true);
        setInsideStickerClicked(true);

        analyticsManager.logOpenInsideTag(props.storyId, playMode, true);

        if (appAnalyticsManager)
            appAnalyticsManager.clickedInside();

        if (getStoredPixelConsent() === 'accepted') {
            if (window.ttq){
                window.ttq.track('ViewContent', {                
                    "contents": [
                        {              
                            "content_id": "0",           
                            "content_name": "inside",
                        }
                    ],
                });
            }
            if (window.fbq){                    
                window.fbq('track', 'ViewContent', {"content_name": "inside"});
            }
        }
    };      

    function selectForFullScreen(idx, media){                            
        if (props.story.menuTypeShown === "gallery")
            return;    
           
        const slides = document.getElementsByClassName("slide selected");      
        try{
            if (slides != null && slides.length !== 0){
                slides[0].children[0].children[0].pause();                
            }
        } catch(error){
            Sentry.captureMessage(printObj(error));
        }
                        
        if (props.mediasType === menuType){              
            if (props.story.menuId != null && props.story.menuOptimizedFormat && props.story.menuTypeShown === "optimized"){                    
                setIsMenuOpened(true);      
                if (props.fromMaker)
                    props.setStoryPreviewCurrentScreen("menu");
                analyticsManager.logOpenFullMenuTag(props.storyId, playMode, "internal", true);
            }
            else {                
                if (playMode === "preview" && props.story.menuReformatDate != null && props.story.menuTypeShown === "optimized" || playMode == "demo" || isCafeUprealityDemoStoryId(props.storyId)){                    
                    setIsMenuOpened(true);                        
                    if (props.fromMaker)
                        props.setStoryPreviewCurrentScreen("menu");  
                    analyticsManager.logOpenFullMenuTag(props.storyId, playMode, "internal", true);
                }
                else {
                    const language = browserLocales(true)[0] === "fr" ? "fr" : "en";                    
                    if (language === "fr" && props.story.menuFile || language === "en" && !props.story.menuFileEn) {
                        window.open(props.story.menuFile, "_blank");
                    }
                    else if (language === "en" && props.story.menuFileEn || language === "fr" && !props.story.menuFile) {
                        window.open(props.story.menuFileEn, "_blank");
                    } 

                    analyticsManager.logOpenFullMenuTag(props.storyId, playMode, "external", true);
                }                
            }
        }
        /*else {
            props.setFullScreen(media, true);
            analyticsManager.logPlayContentTag("full_screen", media);        
        }*/
              
    }       

    useEffect(() => {
        if (activeFeature !== "menu" || props.mediasType !== menuType || isMediasGalleryOpened) {
            return;
        }

        setIsMediasGalleryOpened(true);
        setMenuStickerClicked(true);
        analyticsManager.logOpenMenuTag(props.storyId, playMode, true);

        if (appAnalyticsManager) {
            appAnalyticsManager.clickedMenu();
        }

        if (getStoredPixelConsent() === 'accepted') {
            if (window.ttq) {
                window.ttq.track('ViewContent', {
                    "contents": [
                        {
                            "content_id": "0",
                            "content_name": "menu",
                        }
                    ],
                });
            }
            if (window.fbq) {
                window.fbq('track', 'ViewContent', {"content_name": "menu"});
            }
        }

        if (props.story.menuTypeShown === "external" || props.story.menuTypeShown === "optimized") {
            setCloseGalleryWithMenu(true);
            selectForFullScreen(0, null);
            if (props.story.menuTypeShown === "external" || props.story.menuTypeShown === "optimized" && !props.story.menuId && (!props.story.menuReformatDate || props.story.menuReformatDate && (playMode === "play" || playMode === "review")) && !props.story.menuId && playMode !== "demo" && !isCafeUprealityDemoStoryId(props.storyId)) {
                propagateFocusChange(true);
            }
        }
    }, [activeFeature, isMediasGalleryOpened, props.mediasType]);
    
    function closeOrFullScreen(clientEvent){             
        let relativeX = clientEvent.clientX - (windowDimensions.width - storyDimensions.containerWidth)/2.0; 
        let relativeY = clientEvent.clientY - (windowDimensions.height - storyDimensions.containerHeight)/2.0 ;        
        if (props.fromMaker && ! isTabletOrMobile){     
            relativeX = clientEvent.clientX - (window.innerWidth - storyDimensions.containerWidth)/2.0;       
            relativeY = clientEvent.clientY - (window.innerHeight - (storyDimensions.containerHeight + 40))/2.0 - 40;
        }     
        if (playMode === "demo"){
            relativeX = clientEvent.clientX - document.getElementsByClassName("App")[0].getBoundingClientRect().left;
            relativeY = clientEvent.clientY - document.getElementsByClassName("App")[0].getBoundingClientRect().top;
        }   
        let selectedMediaContainer = document.getElementsByClassName("selected slide")[0];
        if (selectedMediaContainer == null){
            selectedMediaContainer = document.getElementsByClassName("slide")[0];
        }
        
        const firstContent = selectedMediaContainer == document.getElementsByClassName("slide")[0];        
        const isMenu = firstContent;        

        const isImg = selectedMediaContainer.getElementsByTagName('img')[1] != null;
        const selectedMedia = isImg ? selectedMediaContainer.getElementsByTagName('img')[1] : selectedMediaContainer.getElementsByTagName('video')[0];   
        
        // on desktop emulating mobile, a click event can be triggered at gallery opening - see Sticker.js > onStickerTouchEnd
        if (selectedMedia == null && !isMenu){            
            return;
        }

        let contentWidth = 0;
        let contentHeight = 0;
        if (isMenu){
            contentWidth = Math.min(storyDimensions.containerWidth - 32 * sizeMultiplier, 400);
            contentHeight = menuHeight;
        }   
        else {
            contentWidth = parseInt(isImg ? selectedMedia.width : selectedMedia.offsetWidth);
            contentHeight = parseInt(isImg ? selectedMedia.height : selectedMedia.offsetHeight);
        }  
        
        if (relativeY < (storyDimensions.containerHeight - contentHeight)/2.0){          
            propagateFocusChange(true);
        }
        else if (relativeY > (storyDimensions.containerHeight - contentHeight)/2.0 + contentHeight){                               
            propagateFocusChange(true);
        }
        else if (relativeX < (storyDimensions.containerWidth - contentWidth)/2.0){
            propagateFocusChange(true);
        }
        else if (relativeX > (storyDimensions.containerWidth - contentWidth)/2.0 + contentWidth){
            propagateFocusChange(true);
        }
        else {                 
            if (isMenu){   
                // workaround - for some reason opening the menu sticker (with 1 menu file + 1 dish img) make automatically a click on the gallery which would open the menu file
                if (!document.getElementById(idPrefix + "label-" + (firstContent ? 0 : 1))){                    
                    return;
                }                                       
                selectForFullScreen(firstContent ? 0 : 1, "");
            } 
            else if (isImg){                
                selectForFullScreen(selectedMedia.getAttribute('id'), selectedMedia.getAttribute('src'));
            }
        }
    }

    function closeFromButton(e){
        e.stopPropagation();
        propagateFocusChange(true);
    }

    function showCloseButton(){
        if (! checkMobile()) {
            return (
                <div style={{
                    position: 'absolute',
                    bottom: storyDimensions.containerHeight * 1/5 / 2 / 2 - 16 * sizeMultiplier - 36/2 * sizeMultiplier,
                    left: 0,
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 40
                }}>
                    
                    <IconButton
                        onClick={closeFromButton}
                        style={{
                            background: "#fff",
                            borderRadius: "50%",                            
                            padding: 4 * sizeMultiplier,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}                        
                    >                                     
                        <CloseIcon style={{ color: "#808080", fontSize: 24 * sizeMultiplier, width: 28 * sizeMultiplier, height: 28 * sizeMultiplier,}} />                        
                    </IconButton>
                </div>
            );
        }
    }

    const onImgLoaded = (id) => {        
        const imgLoaded = document.getElementById(id); 
        const reloadImage = imgLoaded != null && imgLoaded.naturalWidth > imgLoaded.naturalHeight;       
        if (reloadImage){            
            imgLoaded.style.maxHeight = null;
            imgLoaded.style.maxWidth = storyDimensions.containerWidth - 32 * sizeMultiplier + "px";
            imgLoaded.style.height = (storyDimensions.containerHeight / 2) + "px";                    
        }
    };

    const onVideoLoaded = (id) => {       
        const videoContainer = document.getElementById(id);        
        let videoTag = null;
        if (videoContainer != null){
            videoTag = videoContainer.getElementsByTagName("video")[0];
        }
        
        if (videoTag != null && videoTag.videoWidth > videoTag.videoHeight && videoTag.style.objectFit !== "cover"){  
            videoContainer.style.maxWidth = null;
            videoTag.style.maxWidth = null;
            videoTag.style.maxHeight = null;          
            videoTag.style.width = storyDimensions.containerWidth - 32 * sizeMultiplier + "px";
            videoTag.style.height = (storyDimensions.containerHeight / 2) + "px";
            videoTag.style.objectFit = "cover";                       
        }        
    };

    function disableVolumeButtons(videoId, idx){
        const videoContainer = document.getElementById(videoId);        
        let videoTag = null;
        if (videoContainer != null){
            videoTag = videoContainer.getElementsByTagName("video")[0];
        }
        if (videoTag){            
            const hasAudio = videoTag.mozHasAudio || Boolean(videoTag.webkitAudioDecodedByteCount) || Boolean(videoTag.audioTracks && videoTag.audioTracks.length);            
            if (! hasAudio){
                const volumeBtnOn = document.getElementById(idPrefix + "volume-btn" + idx + "-on");
                const volumeBtnOff = document.getElementById(idPrefix + "volume-btn" + idx + "-off");
                if (volumeBtnOn != null && volumeBtnOff != null){                    
                    volumeBtnOn.style.visibility = "hidden";
                    volumeBtnOff.style.visibility = "hidden";
                }
            }
        }
    }

    const addVolumeToVideo = (idx, contentHeight, contentWidth = null, isVideo = false) => {     
        
        // by simplicity no mini multiplier on height               
        if (document.getElementById(idPrefix + "label-" + idx) != null){
            return;        
        }        

        let videoLeft = 0;
        if (contentWidth != null){            
            videoLeft = Math.max((storyDimensions.containerWidth - 32 * sizeMultiplier - contentWidth)/2 , 0) + "px";                          
        }
        else
        videoLeft = "0px";

        if (isVideo){
            const volumeBtnOn = document.getElementById(idPrefix + "volume-btn" + idx + "-on");
            const volumeBtnOff = document.getElementById(idPrefix + "volume-btn" + idx + "-off");
            if (volumeBtnOn != null && volumeBtnOff != null){
                volumeBtnOn.style.right = videoLeft;
                volumeBtnOff.style.right = videoLeft;
                if (contentHeight < Math.round(storyDimensions.containerHeight * 4/5)){                    
                    const bottomMargin = (storyDimensions.containerHeight * 4/5 - contentHeight) / 2;
                    volumeBtnOn.style.bottom = storyDimensions.containerHeight * 1/10 - sizeMultiplier * 16 + bottomMargin + "px";
                    volumeBtnOff.style.bottom = storyDimensions.containerHeight * 1/10 - sizeMultiplier * 16 + bottomMargin + "px";
                }
                volumeBtnOn.style.visibility = "visible";
            }
        }          
    };

    function showContent(css){        
        if (props.mediasType === menuType && props.story.menuCover && css.idx === 0){                    
            let titleStyle: CSSProperties = {};
            let imgSrc = "";
            let imgStyle: CSSProperties = {};            

            switch (props.story.menuStyle){
                case "elegant":
                    titleStyle = {marginTop: -54 * sizeMultiplier, color: secondaryColor, fontSize: 64 * sizeMultiplier, fontFamily: "'Alex Brush'", };
                    imgSrc = "/images/separatorElegant.png";
                    // TODO make it proportional to text length
                    imgStyle = {marginTop: 20 * sizeMultiplier, width: 160 * sizeMultiplier, height:11 * sizeMultiplier};                    
                    break;
                case "friendly":
                    titleStyle = {marginTop: -36 * sizeMultiplier, color: secondaryColor, fontSize: 56 * sizeMultiplier, fontFamily: 'Roboto condensed', fontWeight: 'bold'};
                    imgSrc = "/images/separatorFriendly.png";
                    imgStyle = {marginTop: 20 * sizeMultiplier, width: 160 * sizeMultiplier, height:20 * sizeMultiplier};                    
                    break;
                case "modern":
                    titleStyle = {color: secondaryColor, fontSize: 48 * sizeMultiplier, fontFamily: 'Roboto condensed', fontWeight: 'bold'};
                    imgSrc = "";
                    imgStyle = {};                    
                    break;
                case "simple":                    
                    titleStyle = {marginTop: -54 * sizeMultiplier, color: secondaryColor, fontSize: 56 * sizeMultiplier, fontFamily: 'Roboto'};
                    imgSrc = "/images/separatorSimple.png";
                    imgStyle = {marginTop: 20 * sizeMultiplier, width: 160 * sizeMultiplier, height:4 * sizeMultiplier};                    

                    break;
            }

            const logoY = (storyDimensions.containerHeight - menuHeight) / 2 + menuHeight - 16 * sizeMultiplier - 16 * sizeMultiplier - 48 * sizeMultiplier;            
            
            if (props.story.menuStyle !== "modern"){                
                return (
                    <div id={idPrefix + "container-"+css.idx} className="medias-gallery-menu" style={{margin: "auto", background: primaryColor, width: Math.min(storyDimensions.containerWidth - 32 * sizeMultiplier, 400)/*storyDimensions.containerWidth - 32 * sizeMultiplier*/, height: menuHeight}}>     
                        <img
                          src="data:image/svg+xml,%3Csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%201%201'%20preserveAspectRatio='none'%3E%3C/svg%3E"
                          alt={t('SpacerAlt')}
                          width="100%"
                          height="100%"
                          style={{position: 'absolute'}}
                        />                           
                        <div style={{...titleStyle, marginLeft: 16, marginRight: 16}}>{t('SignaturesDishes')}</div>        
                        <Image id={idPrefix + "container-"+css.idx+"-img"} alt={t('MenuHeaderStyleAlt')} source={imgSrc} style={{ ...imgStyle}} tintColor={secondaryColor} />    
                        {props.story.avatarUrl && <div id="restaurant-infos-avatar" name="restaurant-infos-avatar" style={{position: 'absolute', top: logoY, width: 48 * sizeMultiplier, height: 48 * sizeMultiplier}}>
                            <img alt={t('RestaurantAvatarAlt')} src={props.story.avatarUrl} className="FBAvatarContainer" style={{width: 48 * sizeMultiplier, height: 48 * sizeMultiplier}} />                                    
                        </div>} 
                    </div>
                );
            }
            else {          
                const titleSizeRoboto = getTextWidth("Signature", 56 * sizeMultiplier + "px Roboto condensed");     
                const frameHeight = 176; 
                const frameWidth = 138;
                const separatorLeftX = 0;
                const separatorRightX = separatorLeftX + titleSizeRoboto + (32 - frameWidth + 32) * sizeMultiplier;
                const titleY = (storyDimensions.containerHeight - menuHeight)/2 + (menuHeight - frameHeight * sizeMultiplier) * (sizeMultiplier >= 1 ? 2.5/7 : 2/7);                     
                return (                    
                    <div id={idPrefix + "container-"+css.idx} className="medias-gallery-menu" style={{margin: "auto", background: primaryColor, width: Math.min(storyDimensions.containerWidth - 32 * sizeMultiplier, 400)/*storyDimensions.containerWidth - 32 * sizeMultiplier*/, height: menuHeight}}> 
                        <img
                          src="data:image/svg+xml,%3Csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%201%201'%20preserveAspectRatio='none'%3E%3C/svg%3E"
                          alt={t('SpacerAlt')}
                          width="100%"
                          height="100%"
                          style={{position: 'absolute'}}
                        />
                        <div style={{position: 'absolute', top: titleY, width: titleSizeRoboto + 64 * sizeMultiplier, height: frameHeight * sizeMultiplier}}>                            
                            <div className='medias-gallery-menu-modern-title' style={{...titleStyle}}>{t('SignaturesDishes')}</div>
                            <Image id={idPrefix + "container-"+css.idx+"-img1"} alt={t('MenuHeaderStyleAlt')} source={"/images/separatorsModern.png"/*"/images/separatorModernLeft.png"*/} style={{left: separatorLeftX, height: frameHeight * sizeMultiplier, width: frameWidth * 2 * sizeMultiplier, position:'absolute', top: '50%', transform: 'translate(0%, -50%)'}} tintColor={secondaryColor}/>
                            {/*<Image id={idPrefix + "container-"+css.idx+"-img2"} alt="menu header style" source="/images/separatorModernRight.png" style={{left: separatorRightX, height: frameHeight * sizeMultiplier, width: frameWidth * sizeMultiplier, position:'absolute', top: '50%', transform: 'translate(0%, -50%)'}} tintColor={secondaryColor}/>*/}
                        </div>   
                        {props.story.avatarUrl && <div id="restaurant-infos-avatar" name="restaurant-infos-avatar" style={{position: 'absolute', top: logoY, width: 48 * sizeMultiplier, height: 48 * sizeMultiplier}}>
                            <img alt={t('RestaurantAvatarAlt')} src={props.story.avatarUrl} className="FBAvatarContainer" style={{width: 48 * sizeMultiplier, height: 48 * sizeMultiplier}} />                                    
                        </div>}                                                                                  
                    </div>
                );
            }
        } 
        else {         
            
            function onImgLoad(){
                onImgLoaded(idPrefix + css.idx); 
                
                const imgElement = document.getElementById(idPrefix + css.idx);
                let imgWidth = imgElement.width;
                let imgHeight = imgElement.height;
                
                const maxWidth = Math.min(storyDimensions.containerWidth-32 * sizeMultiplier, 400);
                const maxHeight = storyDimensions.containerHeight * 4/5;
                // the natural width is returned insead of the html element one
                const bug = imgElement.width > maxWidth && imgElement.height > maxHeight;
                if (bug){                    
                    if (imgElement.naturalHeight > imgElement.naturalWidth){
                        imgWidth = maxWidth
                        const imgHeightCalc = imgWidth * imgElement.naturalHeight / imgElement.naturalWidth;
                        imgHeight = Math.min(imgHeightCalc, maxHeight);
                    }
                    else {
                        imgHeight = storyDimensions.containerHeight / 2;                                                
                        imgWidth = Math.min(imgElement.naturalWidth * imgHeight / imgElement.naturalHeight, maxWidth);    
                    }
                }
                imgElement.style.visibility = "visible";
            }

            return (<div id={idPrefix + "container-" + css.idx} style={{height: storyDimensions.containerHeight-32, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>                    
                    <img
                      style={{position: "absolute"}}
                      src="data:image/svg+xml,%3Csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%201%201'%20preserveAspectRatio='none'%3E%3C/svg%3E"
                      alt={t('SpacerAlt')}
                      width="100%"
                      height="100%"
                    />
                    {<img onLoad={()=>{onImgLoad();}} id={idPrefix + css.idx} alt={t('RestaurantContent')} src={css.url} style={{maxWidth: Math.min(storyDimensions.containerWidth-32 * sizeMultiplier, 400), maxHeight: storyDimensions.containerHeight * 4/5, objectFit: 'cover', position: 'relative', visibility: 'hidden'}}/>}
                </div>);
        }
    }

    const ImgSlide = (css) => {
        let clicker = null;      
        // gallery click for desktop
        if (! checkMobile()){
            clicker = () => selectForFullScreen(css.idx, css.url);
        }

        return (
            <div key={css.url} style={{height: storyDimensions.containerHeight - 32 * sizeMultiplier, display: 'flex', flexDirection: "column", justifyContent: "center"}} onClick={clicker}>                            
                <div className='not-selectable' style={{display: 'flex', flexDirection: "column", justifyContent: "center"}}>
                    {showContent(css)}                    
                </div>                
            </div>     
        );
    };

    function retry(){
        if (retries < retriesNb){
            const slides = document.getElementsByClassName("slide");    
            try{    
                if (slides != null && slides.length !== 0){
                    slides[0].children[0].children[0].load();
                }
            } catch(error){
                Sentry.captureMessage(printObj(error));
                setRetries(retries + 1);
            }
        }
    }
    
    const VideoSlide = (css) => {
        let clicker = null;
        // gallery click for desktop
        if (! checkMobile()){
            clicker = () => selectForFullScreen(css.idx, css.url);
        }
        const isSelected = css.isSelected || neverSwiped && css.idx === 0 && document.getElementsByClassName["slide selected"] == null;        

        function getVideoDisplayedWidthFromVideoTag(){
            const videoTag = document.getElementById(idPrefix + css.idx).getElementsByTagName("video")[0];
            const trueVideoAspectRatio = videoTag.videoHeight / videoTag.videoWidth;
            const videoDisplayedWidth = videoTag.offsetHeight / trueVideoAspectRatio;

            return videoDisplayedWidth;
        }

        function toggleSound(e){            
            e.stopPropagation();
            const video = document.getElementById(idPrefix + css.idx).getElementsByTagName("video")[0];
            const volumeBtnOn = document.getElementById(idPrefix + "volume-btn" + css.idx + "-on");
            const volumeBtnOff = document.getElementById(idPrefix + "volume-btn" + css.idx + "-off");
            if (video != null && volumeBtnOn != null && volumeBtnOff != null){
                const ambiantPlayer = document.getElementById(idPrefix + "audio-player");
                if (video.muted){
                    video.muted = false;
                    video.pause();
                    video.currentTime = 0;
                    video.play();
                    volumeBtnOff.style.visibility = "visible";
                    volumeBtnOn.style.visibility = "hidden";
                    if (musicPlayingAtOpening && ambiantPlayer){
                        ambiantPlayer.pause();
                    }  
                    if (getStoredPixelConsent() === 'accepted') {
                        if (window.ttq){
                            window.ttq.track('GallerySoundAdded');
                        }  
                        if (window.fbq){                    
                            window.fbq('trackCustom', 'GallerySoundAdded');
                        }
                    }                      
                }
                else {
                    video.muted = true;
                    volumeBtnOff.style.visibility = "hidden";
                    volumeBtnOn.style.visibility = "visible";
                    if (musicPlayingAtOpening && ambiantPlayer){                                          
                        ambiantPlayer.play();
                    }
                    if (getStoredPixelConsent() === 'accepted') {
                        if (window.ttq){
                            window.ttq.track('GallerySoundRemoved');
                        }
                        if (window.fbq){                    
                            window.fbq('trackCustom', 'GallerySoundRemoved');
                        }
                    } 
                }
            }
            
        }
        
        let poster = "/images/transparent_image.png";
        if (isIpad() && isInstagramInAppBrowser()){
            poster = "/images/ic_play_v.png";
            clicker = ()=>{
                const reactPlayerContainer = document.getElementById(idPrefix + css.idx);
                if (reactPlayerContainer != null){
                    const video = reactPlayerContainer.getElementsByTagName("video")[0];
                    if (video){
                        video.play();
                    }
                }
            };
        }

        function getValidVideoHeight(videoHeight){
           return Math.floor(videoHeight / 4) * 4;
        }

        function adjustVideoHeight(){
            const videoElement = document.getElementById(idPrefix + css.idx).getElementsByTagName("video")[0];
            const validHeight = getValidVideoHeight(videoElement.offsetHeight);
            videoElement.style.height = validHeight + "px";
            videoElement.parentElement.style.height = validHeight + "px";
            return validHeight;
        }

        return (
                <div id={idPrefix + "container-"+css.idx} style={{height: storyDimensions.containerHeight - 32 * sizeMultiplier, display: 'flex', flexDirection: "column", justifyContent: "center", }}>
                    <div style={{display: 'flex', flexDirection: "column", justifyContent: "center", alignItems: "center"}}>
                        {<ReactPlayer id={idPrefix + css.idx} style={{maxWidth: Math.min(storyDimensions.containerWidth-32 * sizeMultiplier, 400), maxHeight: getValidVideoHeight(storyDimensions.containerHeight*4/5)}} onStart={()=>{onVideoLoaded(idPrefix + css.idx);if (!(isIpad() && isInstagramInAppBrowser())) {addVolumeToVideo(css.idx, adjustVideoHeight(), getVideoDisplayedWidthFromVideoTag(), true);}disableVolumeButtons(idPrefix + css.idx, css.idx);}} onError={() => retry()} onClick={clicker} width="100%" height="100%" url={css.url} playing={isSelected} playsinline muted={true} loop={true}  config={{attributes: {poster: poster, disablePictureInPicture: true}}}/>}                                   
                    </div>                    
                    <IconButton id={idPrefix + "volume-btn" + css.idx + "-on"} style={{visibility: 'hidden', position: 'absolute', bottom: storyDimensions.containerHeight * 1/10 - sizeMultiplier * 16,  right: 0, padding: 8 * sizeMultiplier}} onClick={(e)=>toggleSound(e)}>
                        <VolumeOffIcon style={{color: '#FFFFFF90', width: 32 * sizeMultiplier, height:32 * sizeMultiplier}} />
                    </IconButton>                    
                    <IconButton id={idPrefix + "volume-btn" + css.idx + "-off"} style={{visibility: 'hidden', position: 'absolute', bottom: storyDimensions.containerHeight * 1/10 - sizeMultiplier * 16, right: 0,  padding: 8 * sizeMultiplier}} onClick={(e)=>toggleSound(e)}>
                        <VolumeUpIcon style={{color: '#FFFFFF90', width: 32 * sizeMultiplier, height:32 * sizeMultiplier}} />
                    </IconButton>     
                </div>
            );
    }

    let mediasList = [];
    if (props.medias != null){
        mediasList = props.medias.map((media, idx) => {
                const fileFormat = getFileFormat(getFileNameFromUrl(media));

                let idxFinal = parseInt(idx); 
                if (props.mediasType === menuType)
                    idxFinal = parseInt(idx) + (props.story.menuCover ? 1 : 0);
                if (isImg(fileFormat)){                               
                    return (
                        <ImgSlide key={media} url={media} idx={idxFinal} />
                    );    
                }
                else if (isVideo(fileFormat)){
                    // TODO pas de key ???
                    return (
                        <VideoSlide key={media} url={media} idx={idxFinal} />
                    );
                }
                else {

                    return null;
                }
                
            }     
        );
    }
    if (props.mediasType === menuType && props.story.menuCover){   
        const language = browserLocales(true)[0] === "fr" ? "fr" : "en";
        let keyUrl = "";
        if (language === "fr" && props.story.menuFile || language === "en" && !props.story.menuFileEn) {
            keyUrl = props.story.menuFile;
        }
        else if (language === "en" && props.story.menuFileEn || language === "fr" && !props.story.menuFile) {
            keyUrl = props.story.menuFileEn;
        }        
        mediasList.unshift(<ImgSlide key={keyUrl} url={keyUrl} idx={0} />);
    }   

    const arrowStylesLeft: CSSProperties = {
        position: 'absolute',
        zIndex: 2,
        top: "calc(50% - "+ (24) + "px)",
        width: 48,
        height: 48,
        background: '#FFFFFF00',
        border: 0,        
    };

    const arrowStylesRight: CSSProperties = {
        position: 'absolute',
        zIndex: 2,
        top: "calc(50% - "+ (24) + "px)",
        width: 48,
        height: 48,
        background: '#FFFFFF00',
        border: 0,        
    };

    const customRenderItem = (item, props) => {
        return <item.type {...item.props} {...props} />
    };

    // swipe previous close the web page    
    const swipeable = ! (isTikTokInAppBrowser() && isIOS() && !isAndroid()); 

    function swipeContent(){
        setNeverSwiped(false);
        muteGalleryVideos();
        if (musicPlayingAtOpening){
            const ambiantPlayer = document.getElementById(idPrefix + "audio-player");
            if (musicPlayingAtOpening && ambiantPlayer){
                ambiantPlayer.play();
            }   
        }

        interactedWithGallery = true;    
        if (props.mediasType === menuType){
            analyticsManager.logSwipeMenuTag(props.storyId, playMode);
        }
        else if (props.mediasType === insideType){
            analyticsManager.logSwipeInsideTag(props.storyId, playMode);
        }    
        if (getStoredPixelConsent() === 'accepted') {
            if (window.ttq){
                window.ttq.track('ViewContent', {                
                    "contents": [
                        {              
                            "content_id": "0",           
                            "content_name": "swipe in the " + props.mediasType + " gallery",
                        }
                    ],
                });
            }   
            if (window.fbq){                    
                window.fbq('track', 'ViewContent', {"content_name": "swipe in the " + props.mediasType + " gallery"});
            }
        }         
    }
    
    if (props.medias == null && props.mediasType === insideType && !props.story.promotionImgUrl || props.medias == null && props.mediasType === menuType && props.story.menuTypeShown === "gallery" || props.mediasType === menuType && !props.story.menuTypeShown || props.mediasType === menuType && props.story.menuTypeShown === "external" && !props.story.menuFile && !props.story.menuFileEn || props.mediasType === menuType && props.story.menuTypeShown === "optimized" && !props.story.menuFile && !props.story.menuId && playMode !== "demo" && !isCafeUprealityDemoStoryId(props.storyId)){
        return null;        
    }
    else if (((isMediasGalleryOpened && props.mediasType === menuType) || (isVirtualTourOpened && props.mediasType === insideType && !props.story.promotionImgUrl)) && ((props.mediasType === menuType && activeFeature === "menu") || (props.mediasType === insideType && activeFeature === "inside"))){                     

        return (
            <FadeInPanel
                className="MediasGalleryContainer"
                animationKey={props.mediasType === menuType ? 'sticker-gallery-menu' : 'sticker-gallery-inside'}
                style={galleryPanelRootStyle}
                onClick={(e) => e.stopPropagation()}
            >
                <div id="gallery-overlay" className="BlockingOverlay" style={{width: storyDimensions.containerWidth, height: storyDimensions.containerHeight, background: "#FFFFFFD0", pointerEvents: isMenuOpened ? 'auto' : 'none'}} onClick={(e) => e.stopPropagation()}/>
                    {!isMenuOpened &&
                        <div className="MediasGalleryTitle" style={{borderRadius: 20, height: 24 * sizeMultiplier, paddingLeft: 8 * sizeMultiplier, paddingRight: 8 * sizeMultiplier, fontSize: 16 * sizeMultiplier, marginTop: storyDimensions.containerHeight * 1/5 / 2 / 2 - 24/2 * sizeMultiplier, left: "50%", background: "white", transform: "translate(-50%, 0)", display: 'flex', justifyContent: 'center', alignItems: 'center'}}>{title}</div>
                    }
                    <div id="gallery-container" className="MediasGallery" style={{width: storyDimensions.containerWidth - 32 * sizeMultiplier, height: storyDimensions.containerHeight - 32 * sizeMultiplier, visibility: isMenuOpened ? 'hidden' : 'visible'}} onClick={(e)=>{if (checkMobile()) closeOrFullScreen(e);}}>
                        <Carousel swipeable={swipeable} selectedItem={/*selectedItemInCarousel != null ? selectedItemInCarousel :*/ 0} showArrows={! checkMobile() || isTikTokInAppBrowser() && isIOS() && !isAndroid() || isFirefox() && isAndroid()/* same cond reused in this file */} showStatus={false} showThumbs={false} dynamicHeight={true}  showIndicators={false} onChange={swipeContent}
                            renderArrowPrev={(onClickHandler, hasPrev, label) =>                         
                                hasPrev && (
                                    <button type="button" onClick={(e)=>{onClickHandler(); e.stopPropagation();}} title={label} style={{ ...arrowStylesLeft}}>                                
                                        <ArrowCircleLeftIcon onClick={(e)=>{onClickHandler(); e.stopPropagation();}} style={{color: '#FFFFFF90', width: 40 * sizeMultiplier, height: 40 * sizeMultiplier, zIndex: 4}}/>                                
                                    </button>
                                )                    
                            }
                            renderArrowNext={(onClickHandler, hasNext, label) =>
                                hasNext && (
                                    <button type="button" onClick={(e)=>{onClickHandler(); e.stopPropagation();}} title={label} style={{ ...arrowStylesRight, right: 12 * sizeMultiplier}}>                                        
                                            <ArrowCircleRightIcon onClick={(e)=>{onClickHandler(); e.stopPropagation();}} style={{color: '#FFFFFF90', width: 40 * sizeMultiplier, height: 40 * sizeMultiplier, zIndex: 4}}/>                                
                                    </button>
                                )
                            }
                            renderItem={customRenderItem}
                            className="Slide"
                            onSwipeMove={()=>{interactedWithGallery = true;}}
                            >                        
                            {mediasList}                        
                        </Carousel>  
                        {showCloseButton()}                                  
                    </div>  
                {  
                    props.story.posId !== "ChIJC4g4KBNx5kcRH_z3vKUpnZw"  &&
                        <Menu show={isMenuOpened} storyId={props.storyId} story={props.story} fromMaker={props.fromMaker} fromMenuEditor={props.fromMenuEditor ? true : false} snackSwipeAlreadyDisplayed={snackSwipeAlreadyDisplayed} setSnackSwipeAlreadyDisplayed={setSnackSwipeAlreadyDisplayed} closeMenu={()=>{
                            setIsMenuOpened(false);
                            if (props.fromMaker)
                                props.setStoryPreviewCurrentScreen(null);
                            if (closeGalleryWithMenu){
                                propagateFocusChange(true);
                                setCloseGalleryWithMenu(false);
                            }
                            }}/>
                }
                {
                    props.story.posId === "ChIJC4g4KBNx5kcRH_z3vKUpnZw"  &&
                        <Infos show={isMenuOpened} storyId={props.storyId} story={props.story} fromMaker={props.fromMaker} snackSwipeAlreadyDisplayed={snackSwipeAlreadyDisplayed} setSnackSwipeAlreadyDisplayed={setSnackSwipeAlreadyDisplayed} closeMenu={()=>{
                            setIsMenuOpened(false);
                            if (props.fromMaker)
                                props.setStoryPreviewCurrentScreen(null);
                            if (closeGalleryWithMenu){
                                propagateFocusChange(true);
                                setCloseGalleryWithMenu(false);
                            }
                            }}/>
                }

            </FadeInPanel>
        );
    }
    else if (isVirtualTourOpened && props.mediasType === insideType && props.story.promotionImgUrl && activeFeature === "inside") {                
        return <Promotion story={props.story} close={closeFromButton}/>;
    }
    else {                
        if (props.mediasType === insideType){
           return <Sticker show={showInside} story={props.story} storyId={props.storyId} stickerType={insideType} open={openVirtualTour}/>;
        }
        else if (props.mediasType === menuType){
            return <Sticker show={showMenu} story={props.story} storyId={props.storyId} stickerType={menuType} open={openMediasGallery}/>;
        }
        else {            
            return null;
        }                        
    }
}    
   
export default StickerGallery;